import PropTypes from 'prop-types';
import React from 'react';
import CompleteCheckmark from "../icon-components/complete-checkmark";
import Attention from "../icon-components/attention";

var DismissibleAlert = function DismissibleAlert(_ref) {
  var style = _ref.style,
      titleText = _ref.titleText,
      subtitleText = _ref.subtitleText,
      buttonText = _ref.buttonText,
      onDismiss = _ref.onDismiss,
      description = _ref.description;
  var containerHighClass = description ? ' DismissibleAlert-high' : '';
  var buttonHighClass = description ? ' DismissibleAlert-high-button' : '';
  var attentionStyle = style === 'danger' ? 'error' : 'incomplete';
  return React.createElement("div", {
    className: "DismissibleAlert DismissibleAlert-".concat(style).concat(containerHighClass)
  }, style === 'success' ? React.createElement(CompleteCheckmark, null) : React.createElement(Attention, {
    status: attentionStyle
  }), React.createElement("div", {
    className: "DismissibleAlert-".concat(style, "-titles")
  }, React.createElement("h3", {
    className: "DismissibleAlert-".concat(style, "-title")
  }, titleText), React.createElement("p", {
    className: "DismissibleAlert-".concat(style, "-subtitle")
  }, subtitleText), description && React.createElement("div", {
    className: "DismissibleAlert-".concat(style, "-description")
  }, description)), buttonText && React.createElement("button", {
    type: "submit",
    className: "DismissibleAlert-".concat(style, "-button").concat(buttonHighClass),
    onClick: onDismiss
  }, buttonText));
};

DismissibleAlert.propTypes = {
  style: PropTypes.oneOf(['danger', 'default', 'success', 'warning']),
  titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
  subtitleText: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
  buttonText: PropTypes.string,
  onDismiss: PropTypes.func,
  description: PropTypes.any
};
DismissibleAlert.defaultProps = {
  style: 'default',
  buttonText: 'DISMISS',
  description: null,
  onDismiss: function onDismiss() {}
};
DismissibleAlert.displayName = 'DismissibleAlert';
export default DismissibleAlert;